import React from "react";
import { useLocation } from "react-router-dom";
import { FaRegCircle, FaRegDotCircle } from "react-icons/fa";
import { IoCheckmarkCircle } from "react-icons/io5";

const ProgressBar = ({ page, steps }) => {
  const location = useLocation();

  switch (steps) {
	case 3:
		return(
        <div className='grid grid-cols-3'>
			<div className='flex flex-col items-center'>
				{page === 0 ? (
					<div className='flex items-center'>
						<div className='w-10 sm:w-80 border-b-2 border-[#F4F4F7]' />
						<FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-[#F4F4F7] z-2' />
						<div className='w-10 sm:w-80 border-b-2 border-[#D5D5D8]' />
					</div>
				) : (
					<div className='flex items-center'>
						<div className='w-10 sm:w-80 border-b-2 border-[#F4F4F7]' />
						<IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-[#F4F4F7] z-2' />
						<div className='w-10 sm:w-80 border-b-2 border-[var(--color-primary-purple)]' />
					</div>
				)}
				<div className='text-sm font-semibold my-1'>
					Information
				</div>
			</div>

			<div className='flex flex-col items-center'>
				{page === 1 ? (
					<div className='flex items-center'>
						<div className='w-10 sm:w-80 border-b-2 border-[var(--color-primary-purple)]' />
						<FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-[#F4F4F7] z-2' />
						<div className='w-10 sm:w-80 border-b-2 border-[#D5D5D8]' />
					</div>
				) : page > 1 ? (
					<div className='flex items-center'>
						<div className='w-10 sm:w-80 border-b-2 border-[var(--color-primary-purple)]' />
						<IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-[#F4F4F7] z-2' />
						<div className='w-10 sm:w-80 border-b-2 border-[var(--color-primary-purple)]' />
					</div>
				) : (
					<div className='flex items-center'>
						<div className='w-10 sm:w-80 border-b-2 border-[#D5D5D8]' />
						<FaRegCircle className='text-4xl text-[#D5D5D8] bg-[#F4F4F7] z-2' />
						<div className='w-10 sm:w-80 border-b-2 border-[#D5D5D8]' />
					</div>
				)}
				<div className='text-sm font-semibold my-1'>
					Billing
				</div>
			</div>

			<div className='flex flex-col items-center'>
				{page === 2  ? (
					<div className='flex items-center'>
						<div className='w-10 sm:w-80 border-b-2 border-[var(--color-primary-purple)]' />
						<FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-[#F4F4F7] z-2' />
						<div className='w-10 sm:w-80 border-b-2 border-[#F4F4F7]' />
					</div>
				) : (
					<div className='flex items-center'>
						<div className='w-10 sm:w-80 border-b-2 border-[#D5D5D8]' />
						<FaRegCircle className='text-4xl text-[#D5D5D8] bg-[#F4F4F7] z-2' />
						<div className='w-10 sm:w-80 border-b-2 border-[#F4F4F7]' />
					</div>
				)}
				<div className='text-sm font-semibold my-1'>Confirmation</div>
			</div>
        </div>
		)

    case 4:
      return (
        <div className='grid grid-cols-4'>
          <div className='flex flex-col items-center'>
            {page === 0 ? (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-white' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-white' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            )}
            {location.pathname === "/orders/primer" ? (
              <div className='text-sm font-semibold my-1'>
                Synthesis Information
              </div>
            ) : (
              <div className='text-sm font-semibold my-1'>
                Project Information
              </div>
            )}
          </div>

          <div className='flex flex-col items-center'>
            {page === 1 ? (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[#D5D58]' />
              </div>
            ) : page > 1 ? (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            {location.pathname === "/orders/quoterequest" ? (
              <div className='text-sm font-semibold my-1'>
                Customer Information
              </div>
            ) : (
              <div className='text-sm font-semibold my-1'>
                Billing Information
              </div>
            )}
          </div>
          <div className='flex flex-col items-center'>
            {page === 2 ? (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : page > 2 ? (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className=' w-52 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Verification</div>
          </div>

          <div className='flex flex-col items-center'>
            {page >= 3 && page <= 3 ? (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className=' w-52 border-b-2 border-white' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className=' w-52 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className=' w-52 border-b-2 border-white' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Confirmation</div>
          </div>
        </div>
      );

    case 5:
      return (
        <div className='grid grid-cols-5'>
          <div className='flex flex-col items-center'>
            {page === 0 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-white' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-white' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Sample Information</div>
          </div>

          <div className='flex flex-col items-center'>
            {page === 1 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D58]' />
              </div>
            ) : page > 1 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            {location.pathname === "/orders/genomic" ||
			location.pathname === "/orders/ngs" || location.pathname === "/orders/wps" || location.pathname === "/orders/fsa" || location.pathname === "/orders/fla" ? (
              <div className='text-sm font-semibold my-1'>Estimate</div>
            ) : (
              <div className='text-sm font-semibold my-1'>
                Banking & Synthesis
              </div>
            )}
          </div>
          <div className='flex flex-col items-center'>
            {page === 2 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : page > 2 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>
              Billing & Shipping Information
            </div>
          </div>
          <div className='flex flex-col items-center'>
            {page === 3 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : page > 3 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Verification</div>
          </div>
          <div className='flex flex-col items-center'>
            {page >= 4 && page <= 4 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-white' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-white' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Confirmation</div>
          </div>
        </div>
      );

    case 6:
      return (
        <div className='grid grid-cols-6'>
          <div className='flex flex-col items-center'>
            {page === 0 ? (
              <div className='flex items-center'>
                <div className='w-44 border-b-2 border-white' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-52 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-44 border-b-2 border-white' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-52 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Sample Information</div>
          </div>

          <div className='flex flex-col items-center'>
            {page === 1 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D58]' />
              </div>
            ) : page > 1 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>
              Banking & Synthesis
            </div>
          </div>
          <div className='flex flex-col items-center'>
            {page === 2 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : page > 2 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Estimate</div>
          </div>
          <div className='flex flex-col items-center'>
            {page === 3 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : page > 3 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1 text-center'>
              Billing & Shipping Information
            </div>
          </div>
          <div className='flex flex-col items-center'>
            {page === 4 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            ) : page > 4 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <IoCheckmarkCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Verification</div>
          </div>

          <div className='flex flex-col items-center'>
            {page >= 5 && page <= 5 ? (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[var(--color-primary-purple)]' />
                <FaRegDotCircle className='text-4xl text-[var(--color-primary-purple)] bg-white z-2' />
                <div className='w-48 border-b-2 border-white' />
              </div>
            ) : (
              <div className='flex items-center'>
                <div className='w-48 border-b-2 border-[#D5D5D8]' />
                <FaRegCircle className='text-4xl text-[#D5D5D8] bg-white z-2' />
                <div className='w-48 border-b-2 border-white' />
              </div>
            )}
            <div className='text-sm font-semibold my-1'>Confirmation</div>
          </div>
        </div>
      );
    default:
      break;
  }
};

export default ProgressBar;
